import { render, staticRenderFns } from "./AddBenefitsToClaim.vue?vue&type=template&id=3a2dae4f"
import script from "./AddBenefitsToClaim.vue?vue&type=script&lang=js"
export * from "./AddBenefitsToClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports